import React, { useState, useEffect } from 'react';

const Portada1 = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const headerStyle = {
    position: 'relative',
    width: '100vw',
    minWidth: '100vw',
    height: '95vh',
    minHeight: isMobile ? '60vw' : '400px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    background: '#fff',
    touchAction: 'manipulation', 
  };

  const videoStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    objectFit: 'cover',
    zIndex: 1,
    pointerEvents: 'none',
    minWidth: '100vw',
    minHeight: '100vh',
    maxWidth: '100vw',
    maxHeight: '100vh',
    background: '#e5e5e5',
    transition: 'none',
  };

  const titleStyle = {
    fontFamily: '"Anton", sans-serif',
    color: '#000',
    fontSize: 'clamp(2.2rem, 8vw, 6rem)',
    fontWeight: '900',
    position: 'absolute',
    zIndex: 2,
    wordBreak: 'break-word',
    lineHeight: 1.05,
    margin: 0,
    maxWidth: '92vw',
    ...(isMobile
      ? {
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          width: '90vw',
          padding: '0 2vw',
        }
      : {
          bottom: '2rem',
          left: '2rem',
          textAlign: 'left',
          width: 'auto',
        }),
  };

  return (
    <header style={headerStyle}>
      <video
        style={videoStyle}
        src="/img/BannergifMarco.mp4"
        autoPlay
        loop
        muted
        playsInline
      />
      <h1 style={titleStyle}>LAB-DEMOSS</h1>
    </header>
  );
};

export default Portada1;
